import { render, staticRenderFns } from "./OrganizationView.vue?vue&type=template&id=56a5f784&scoped=true"
import script from "./OrganizationView.vue?vue&type=script&lang=js"
export * from "./OrganizationView.vue?vue&type=script&lang=js"
import style0 from "./OrganizationView.vue?vue&type=style&index=0&id=56a5f784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a5f784",
  null
  
)

export default component.exports